module.exports = __webpack_public_path__ + "img/product-shansuan-zsyy-04.9bc43561.png";